import { Translator } from "@openreply/internationalization";

import at from "./at.json";
import de from "./de.json";

export enum Lang {
  De = "de-DE",
  At = "de-AT",
}

export type TranslationType = typeof de | typeof at;

export const createIntl = () => {
  const lang = window.location.hostname.includes(".obi.at") ? Lang.At : Lang.De;
  if (!document.documentElement.hasAttribute("lang")) {
    document.documentElement.setAttribute("lang", lang);
  }
  return new Translator<TranslationType>(lang, lang === Lang.At ? at : de);
};
